import { render } from "./producer-detail.vue?vue&type=template&id=ff909b0e"
import script from "./producer-detail.vue?vue&type=script&lang=js"
export * from "./producer-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__